
import { fetchChannels } from '@modules/admin/actions';
import Api from '../../../common/services/api';

export default (organisationId, channelId) => async (dispatch) => {
  const { data } = await Api.post(`/v1/organisations/${organisationId}/channels/${channelId}/join`);
  dispatch(fetchChannels());
  return data;
};
